import { render, staticRenderFns } from "./MailDialogV2.vue?vue&type=template&id=7b0e95f0"
import script from "./MailDialogV2.vue?vue&type=script&lang=js"
export * from "./MailDialogV2.vue?vue&type=script&lang=js"
import style0 from "./MailDialogV2.vue?vue&type=style&index=0&id=7b0e95f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports